"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Snackbar = _interopRequireDefault(require("@material-ui/core/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@material-ui/core/SnackbarContent"));
var _styles = require("@material-ui/core/styles");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = require("../Text");
var _theme = require("../utils/theme");
var _Icon = require("../Icon");
var _roundVector = _interopRequireDefault(require("../../assets/images/roundVector.png"));
var _Image = require("../Image");
var _excluded = ["className", "message", "onClose", "variant", "isOpen", "needAttention", "onCheckDetailsClicked"];
var _templateObject;
var variantIcon = {
  success: 'success',
  warning: 'work-warning',
  error: 'error',
  info: 'info-mark-circle'
};
var useStyles1 = (0, _styles.makeStyles)(function () {
  return {
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%'
    },
    divider: {
      border: '0.5px solid rgba(0, 0, 0, 0.04)',
      width: '100%'
    },
    successIcon: {
      backgroundColor: _theme.defaultTheme.color.success.darker
    },
    errorIcon: {
      backgroundColor: _theme.defaultTheme.color.danger.darker
    },
    infoIcon: {
      backgroundColor: _theme.defaultTheme.color.primary.darker
    },
    warningIcon: {
      backgroundColor: _theme.defaultTheme.color.warning.darker
    },
    success: {
      backgroundColor: _theme.defaultTheme.color.success["default"]
    },
    error: {
      backgroundColor: _theme.defaultTheme.color.danger["default"]
    },
    info: {
      backgroundColor: _theme.defaultTheme.color.primary["default"]
    },
    warning: {
      backgroundColor: _theme.defaultTheme.color.warning["default"]
    },
    iconContainer: {
      position: 'absolute',
      top: '-16px',
      right: 'calc(50% - 30px)',
      padding: '6px',
      borderRadius: '50%'
    },
    decorationImage: {
      position: 'absolute',
      top: 0,
      left: 0
    },
    icon: {
      fontSize: 40
    },
    iconVariant: {
      padding: '2px',
      borderRadius: '50%'
    },
    root: {
      width: '100%'
    },
    message: {
      width: '100%'
    },
    msg: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '24px',
      width: '100%'
    }
  };
});
var CheckDetailsText = (0, _styledComponents["default"])(_Text.Text)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 4px;\n  font-weight: bold;\n  text-decoration: underline;\n  cursor: pointer;\n  color: #ffffff;\n"])));
var Notification = function Notification(props) {
  var classes = useStyles1();
  var className = props.className,
    message = props.message,
    onClose = props.onClose,
    variant = props.variant,
    isOpen = props.isOpen,
    _props$needAttention = props.needAttention,
    needAttention = _props$needAttention === void 0 ? false : _props$needAttention,
    onCheckDetailsClicked = props.onCheckDetailsClicked,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var handleClose = function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    onClose(event, reason);
  };
  var getIconByVariant = function getIconByVariant() {
    return variantIcon[variant];
  };
  var getIconClassName = function getIconClassName() {
    return "".concat(variant, "Icon");
  };
  return /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], {
    autoHideDuration: needAttention ? 30000 : 5000,
    onClose: handleClose,
    open: isOpen,
    style: {
      marginTop: '64px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_SnackbarContent["default"], (0, _extends2["default"])({
    className: (0, _clsx["default"])(classes[variant], className, classes.content),
    "aria-describedby": "client-snackbar",
    PaperProps: {
      style: {
        borderRadius: '10px'
      }
    },
    message: /*#__PURE__*/_react["default"].createElement("div", {
      id: "client-snackbar",
      className: classes.msg
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(classes.iconContainer, classes[variant])
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: getIconByVariant(),
      color: "#FFFFFF",
      className: (0, _clsx["default"])(classes.icon, classes.iconVariant, classes[getIconClassName()])
    })), /*#__PURE__*/_react["default"].createElement(_Image.Image, {
      src: _roundVector["default"],
      className: classes.decorationImage
    }), /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      style: {
        textAlign: 'center',
        marginBottom: '8px',
        display: 'flex'
      },
      color: "#FFFFFF"
    }, "".concat(message, "."), onCheckDetailsClicked ? /*#__PURE__*/_react["default"].createElement(CheckDetailsText, {
      onClick: function onClick() {
        onCheckDetailsClicked();
        handleClose();
      }
    }, "Check Details") : null), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.divider
    }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      dense: true,
      size: "small",
      variant: "text",
      style: {
        textTransform: 'none',
        marginTop: '4px',
        width: 'fit-content'
      },
      fullWidth: false,
      onClick: handleClose
    }, /*#__PURE__*/_react["default"].createElement(_Text.Text, {
      type: "small",
      color: "#FFFFFF",
      style: {
        width: 'fit-content'
      }
    }, "Close")))
  }, other)));
};
Notification.propTypes = {
  className: _propTypes["default"].string,
  message: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  variant: _propTypes["default"].oneOf(['error', 'info', 'success', 'warning']).isRequired
};
var _default = exports["default"] = Notification;